/**
 * 使用事件/行为
 * @return {object} { runBehavior }
 */
export function useBehaviour() {
    return window.FEGORender.common.behavior;
}
